export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/orbit-03.03cf5577-a8ce6a.svg";